import '../../css/CardSection.css';

// ✅ Image imports
import icon1 from "../../../assets/icon/1.png";
import icon2 from "../../../assets/icon/2.png";
import icon3 from "../../../assets/icon/3.png";
import icon4 from "../../../assets/icon/4.png";
import icon5 from "../../../assets/icon/5.png";
import icon6 from "../../../assets/icon/6.png";



export default function CardSection() {
  const features = [
    {
      title: "Collaborative Management",
      description:
        "It provides a unified platform to plan, manage, track, and approve testing activities across multiple projects, giving all stakeholders—from test managers to QA leads—real-time visibility into progress, issues, and test quality.",
      image: icon1,
    },
    {
      title:
        "Cloud-Based Web and Mobile Automation with AI-Driven Test Management",
      description:
        "Fully AI-Driven Test Case Generation from requirements and automate web and mobile testing by record-and-play on the cloud-based browser and device.",
      image: icon5,
    },
    {
      title: "Comprehensive Requirement Management",
      description:
        "Through the help of FrothAI, it connects each test scenario and test case with the related business requirements thus enabling QA managers to be certain of total test coverage and following the scope during the lifecycle.",
      image: icon3,
    },
    {
      title: "Test Planning and Resource Forecasting",
      description:
        "This feature helps test managers to create comprehensive test plans, assign resources, set test cycles, estimate efforts, and get approval and sign off - thus elevating test readliness level and lessening the occurrence of delays due to inadequate planning.",
      image: icon4,
    },
    {
      title: "Integrated Defect Lifecycle Management",
      description:
        "Facilitates defect tracking from logging to closure along with detailed metrics like defect aging, severity trends, and closure efficiency—thus allowing test managers to refine defect resolution processes.",
      image: icon2,
    },
    {
      title: "Manual and REST APIs Test Case Execution",
      description:
        "Froth TestOps supports flexible test executions both manual and REST API integration. Tests​‍​‌‍​‍‌​‍​‌‍​‍‌ can be performed manually by users or can be programmatically initiated by them, thus enabling both non-scripted testing and automated ​‍​‌‍​‍‌​‍​‌‍​‍‌workflows.",
      image: icon6,
    },
  ];

  return (
    <section className="card-section pb-5">
      <div className="container text-center">

        <h2 className="card-title mb-5">
          Testing teams can easily work with the help of{" "}
          <span>Froth TestOps</span>
        </h2>

        <div className="row card-mobile">
          {features.map((feature, index) => (
            <div className="col-md-6 col-lg-4 " key={index}>

              {/* 🔥 WRAPPER (IMPORTANT) */}
              <div className="card-wrapper">

                {/* BLUE BACK SHAPES */}
                <div className="corner top-right"></div>
                <div className="corner bottom-left"></div>

                {/* CARD */}
                <div className="card-box">
                  <div className="card-inner">

                    <img
                      src={feature.image}
                      alt={feature.title}
                      className="card-icon"
                    />

                    <h5 className="card-heading">
                      {feature.title}
                    </h5>

                    <p className="card-text">
                      {feature.description}
                    </p>

                  </div>
                </div>

              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}